(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/after-payment-dialog.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/after-payment-dialog.js');

'use strict';

function afterPayment(_ref) {
  let {
    productName,
    totalCost,
    accountBalance = 0,
    brand,
    next
  } = _ref;
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'games',
    title: "Din ".concat(productName, " f\xF6r ").concat(totalCost, " kr \xE4r betald"),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: brand === 'triss' ? 'Insättningen och betalningen lyckades och du kan börja skrapa din lott.' : 'Insättningen och betalningen lyckades och du kan börja spela.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Ditt saldo: ".concat(accountBalance, " kr")
    }],
    actions: [{
      title: brand === 'triss' ? 'Skrapa nu' : 'Spela nu',
      callback: (e, forms, dialog) => {
        dialog.close();
        next === null || next === void 0 || next();
      }
    }]
  }));
}
setGlobal('svs.ticketgames.ticketUtility.utils.afterPayment', afterPayment);

 })(window);